import React, { useContext, useMemo } from "react";
import { PurchaseValidationContext } from "./PurchaseValidationContext";
import { useSearchParams } from "../Hooks/useSearchParams";
import { DrawInput } from "../common/Inputs/DrawInput";
import MixpanelService from "../utils/MixpanelService";

export const PurchaseValidationDraw = () => {
  const {
    downloadPath,
    networks,
    manufacturers,
    coveredEntity340bIds,
    setCoveredEntity340bId,
    coveredEntity340bId,
    setManufacturer,
    manufacturer,
    setNetwork,
    network,
  } = useContext(PurchaseValidationContext);

  const manufacturerOptions = useMemo(
    () => [{ label: "All", value: "all" }, ...manufacturers],
    [manufacturers]
  );

  const networkOptions = useMemo(
    () => [{ label: "All", value: "all" }, ...networks.map((id) => ({ label: id, value: id }))],
    [networks]
  );

  const coveredEntityOptions = useMemo(
    () => coveredEntity340bIds.map((id) => ({ label: id, value: id })),
    [coveredEntity340bIds]
  );

  const [searchParams, setSearchParams] = useSearchParams();

  const handleInputChange = (resolver, value, urlName) => {
    setSearchParams({ ...searchParams, [urlName]: value });
    resolver(value);
  };

  return (
    <div className="draw__container draw__container--scroll">
      <div className="flex align-items-center justify-content-end pt-2">
        <a
          href={`${downloadPath}?manufacturer=${manufacturer}&id_340b=${coveredEntity340bId}&network=${network}`}
          download
          target="_blank"
        >
          <button
            className="button button--white px-3 py-2"
            onClick={() => MixpanelService.track("esp_horizon_purch_val_downloaded")}
          >
            Download File
          </button>
        </a>
      </div>
      <div className="draw__divider" />

      <DrawInput
        label="Covered Entity"
        items={coveredEntityOptions}
        selected={coveredEntity340bId}
        setSelected={(val) => handleInputChange(setCoveredEntity340bId, val, "id_340b")}
        required={true}
      />

      <div className="draw__divider" />

      <DrawInput
        label="Manufacturer"
        items={manufacturerOptions}
        selected={manufacturer}
        setSelected={(val) => handleInputChange(setManufacturer, val, "manufacturer")}
        required={true}
      />

      <div className="draw__divider" />

      <DrawInput
        label="Network"
        items={networkOptions}
        selected={network}
        setSelected={(val) => handleInputChange(setNetwork, val, "network")}
        required={true}
      />
    </div>
  );
};
